<template lang="pug">
v-layout(row justify-center)
  v-dialog(v-model="confirm.show" :persistent="confirm.persistent" scrollable :max-width="290")
    v-card
      v-card-title.pb-0
        v-layout(row wrap)
          v-flex(xs10)
            .headline {{ confirm.title }}
          v-flex(xs2)
            v-btn(icon @click.native="hideConfirm")
              v-icon close
      v-card-text {{ confirm.text }}
      v-card-actions
        v-spacer
        v-btn(color="primary" @click.native="resolve") {{ confirm.resolveText }}
        v-btn(color="primary" flat @click.native="reject") {{ confirm.rejectText }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Confirm',

  computed: {
    ...mapGetters({
      confirm: 'tools/confirm',
    }),
  },

  methods: {
    ...mapActions({
      hideConfirm: 'tools/hideConfirm',
    }),

    resolve() {
      this.confirm.deferred.resolve()
      this.hideConfirm()
    },

    reject() {
      this.confirm.deferred.reject()
      this.hideConfirm()
    },
  },

}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/utils/Confirm.vue